
<label class="switch">
    <input type="checkbox" [checked]="isChecked" (change)="onSwitchChange($event)">
    <span class="slider"></span>
  </label>